import { put, call, takeLatest } from 'redux-saga/effects';
import * as APICommon from '../../services/apiCommon';
import * as SagaCommon from '../../sagas/sagasCommon';

import { 
  GET_ENTITY_PURCHASE_RECEIPTS,
  GET_ENTITY_PURCHASE_RECEIPTS_IN_PROGRESS,
  SET_ENTITY_PURCHASE_RECEIPT_LIST
 } from '../../constants/constant_action_types';

 import {
  setPurchaseReceiptPagination
 } from '../../actions/actionCreatorEntityPurchase';

export function* getEntityPurchaseReceiptsSaga(feathersApp) {
  yield takeLatest(GET_ENTITY_PURCHASE_RECEIPTS, callGetEntityPurchaseReceipts, feathersApp);
}

function* callGetEntityPurchaseReceipts(feathersApp, action) {
  try {
    const { filters = {} } = action;

    yield put({ type: GET_ENTITY_PURCHASE_RECEIPTS_IN_PROGRESS });
    const dataParams = {
      filters: { ...filters },
      list_type: 'purchase_receipt'
    }

    const entityPurchaseReceiptResult = yield call(APICommon.getListData, feathersApp, dataParams);

    let entityPurchaseReceipt = entityPurchaseReceiptResult.docs;

    yield put(setPurchaseReceiptPagination(null, null, entityPurchaseReceiptResult.total));
    yield put({ type: SET_ENTITY_PURCHASE_RECEIPT_LIST, list: entityPurchaseReceipt });

  } catch (error) {
    yield SagaCommon.showErrorListTable(error);
  }
}